var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.color === 'feminist')?_c('b-message',[_vm._v("\n  El color morat està reservat per a targes de temes feministes.\n")]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }